import React from "react";
import LoadingScreen from "../UI/loading-screen";
// import ErrorComponent from '../UI/error';
import ErrorComponent from "../errors/error-box";
import SingleCard from "../UI/single-card";
import MultiCard from "../UI/multi-card";
import ProductSelectMobile from "../UI/product-select-mobile";

const desktopProductView = (dProps, benefitsTranslations) => {
  const {
    products,
    languages,
    selectMembership,
    couponObj,
    locationData,
    isUserLogged,
    locationDataCurrency,
    businessCategories,
  } = dProps || {};

  if (products && products.length > 1) {
    return (
      <MultiCard
        languages={languages}
        products={products}
        selectMembership={selectMembership}
        couponObj={couponObj}
        locationData={locationData}
        isUserLogged={isUserLogged}
        locationDataCurrency={locationDataCurrency}
        businessCategories={businessCategories}
        benefitsTranslations={benefitsTranslations}
      />
    );
  } else {
    return (
      <SingleCard
        languages={languages}
        product={products}
        selectMembership={selectMembership}
        couponObj={couponObj}
        locationData={locationData}
        isUserLogged={isUserLogged}
        locationDataCurrency={locationDataCurrency}
        businessCategories={businessCategories}
        benefitsTranslations={benefitsTranslations}
      />
    );
  }
};

function Product({
  locationData,
  selectMembership,
  languages,
  error,
  isProductLoaded,
  products,
  locationDataCurrency,
  couponObj,
  isUserLogged,
  businessCategories,
  benefitsTranslations,
}) {
  const productData = {
    languages,
    products,
    selectMembership,
    couponObj,
    locationData,
    isUserLogged,
    locationDataCurrency,
    businessCategories,
  };
  if (error) {
    // return (<ErrorComponent errorMessage ={error}/>);
    throw new Error(error);
  } else if (!isProductLoaded) {
    return <LoadingScreen />;
  } else if (
    products &&
    products.length > 1 &&
    locationDataCurrency != products[0].currency_text
  ) {
    // return(<ErrorComponent errorMessage ={'You cannot purchase in '+ products[0].currency_text +". Merchant not available. Please <a href='contact' style='display: contents;'>contact Member Services</a> for more information."} /> )
    throw new Error(
      `You cannot purchase in ${products[0].currency_text}. Merchant not available. Please <a href='contact' style='display: contents;'>contact Member Services</a> for more information.`
    );
  } else if (products && products.length <= 0) {
    // return(<ErrorComponent errorMessage ={'No Memberships available.'} /> )
    throw new Error("No Memberships available.");
  } else {
    return (
      <>
        <div className="xs:hidden tablet:hidden laptop:flex laptop:justify-evenly">
          {desktopProductView(productData, benefitsTranslations)}
        </div>

        <ProductSelectMobile
          className="laptop:hidden"
          languages={languages}
          products={products}
          selectMembership={selectMembership}
          couponObj={couponObj}
          locationData={locationData}
          isUserLogged={isUserLogged}
          locationDataCurrency={locationDataCurrency}
          businessCategories={businessCategories}
          benefitsTranslations={benefitsTranslations}
        />
      </>
    );
  }
}

export default Product;
